import styled from 'styled-components';

export const StyledBackground = styled.div<{ $checked: boolean }>`
  width: 33px;
  height: 18px;
  left: 0px;
  top: 0px;
  position: absolute;
  background: ${({ $checked }) => ($checked ? '#3B8FFD' : '#6E76A6')};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  transition: background 0.2s ease;
`;

export const StyledToggle = styled.div<{ $checked: boolean }>`
  width: 16px;
  height: 16px;
  left: ${({ $checked }) => ($checked ? '16px' : '1px')};
  top: 1px;
  position: absolute;
  background: white;
  border-radius: 9999px;
  transition: left 0.2s ease;
`;

export const StyledStatusLabel = styled.span`
  color: #e8eaf6;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`;

export const StyledSwitch = styled.div<{ $disabled?: boolean }>`
  width: 33px;
  height: 18px;
  position: relative;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

export const StyledSwitchGroup = styled.div`
  align-self: stretch;
  height: 24px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const StyledLabelText = styled.span`
  color: #e8eaf6;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 24px;
  word-wrap: break-word;
`;

export const StyledLabel = styled.p`
  align-self: stretch;
  margin: 0;
`;

export const StyledDescriptionText = styled.span`
  color: #6e76a6;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`;

export const StyledDescription = styled.p`
  align-self: stretch;
  margin: 0;
`;

export const StyledHelperTextSpan = styled.span`
  color: #6e76a6;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`;

export const StyledHelperText = styled.p`
  align-self: stretch;
  margin: 0;
`;

export const StyledLabelColumn = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const StyledSwitchColumn = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;


